import { createTheme } from "baseui";
const primitives = {
  primaryFontFamily: "Verdana, Helvetica, sans-serif, Arial",
};
const overrides = {
  colors: {
    buttonSecondaryFill: primitives.accent100,
    buttonSecondaryText: primitives.accent,
    buttonSecondaryHover: primitives.accent200,
    buttonSecondaryActive: primitives.accent300,
    buttonSecondarySelectedFill: primitives.accent200,
    buttonSecondarySelectedText: primitives.accent,
    buttonSecondarySpinnerForeground: primitives.accent700,
    buttonSecondarySpinnerBackground: primitives.accent300,
  },
  grid: {
    
    // Define gutters for each breakpoint
    // gutter: {
    //   small: '16px',    // For devices up to 1024px wide
    //   medium: '24px',   // For devices from 1024px to 1280px
    //   large: '32px',    // For devices over 1280px wide
    // },
    // // Define columns for each breakpoint
    maxWidth: 1500

  },
  breakpoints: {
    small: 900,
    medium: 1100,
    large: 1280,
  },


};
export const lightTheme = createTheme(primitives, overrides);
